export enum MediaType {
    /**
     * The audio type.
     */
    AUDIO = 'audio',

    /**
     * The presenter type.
     */
    PRESENTER = 'presenter',

    /**
     * The video type.
     */
    VIDEO = 'video'
}
